import { render } from "./MyRoles.vue?vue&type=template&id=389a7014"
import script from "./MyRoles.vue?vue&type=script&lang=js"
export * from "./MyRoles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__